import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {NavLink} from 'react-router-dom';
import Validate from 'app/validation/validation';
import {NewsletterFieldTypes, NewsletterFieldValidationRules, NewsletterFieldInputTypes, NewsletterFieldTypeLabels} from 'app/enums/NewsletterFieldTypes';

import './popupNewsletterForm.scss';
// assets
import submit_footer from 'assets/icons/submit_footer.svg';
import cb_empty from 'assets/icons/cb_empty.svg';
import cb_checked from 'assets/icons/cb_checked.svg';
import {getMediaPath, reactParserCommonOptions} from "../../../app/functions";
import AnalyticsManager from "../../../app/analytics";
import {useSignUpForNewsletterMutation} from "../../../redux/api/relations.api";
import * as Actions from "../../../redux/actions";
import ReactHtmlParser from "react-html-parser";
import {isFulfilled} from "@reduxjs/toolkit";
import {AnalyticsParamValues} from "../../../constants/analytics";
import {isMutationFulfilled} from "../../../api/utils";

const PopupNewsletterForm = ({
                                 className = '',
                                 checkbox_id,
                                 show_img = false,
                                 onSubmit = () => {
                                 },
                                 isShow2Columns,
                                 isShowFormTitle,
                             }) => {
    const dispatch = useDispatch()

    const userData = useSelector(state => state.config.UserData);

    const [signUpForNewsletter, newsletterResult] = useSignUpForNewsletterMutation();

    const parameters = useSelector((store) => {
        return store.config.Parameters
    });

    const newsletterPopup = useSelector(state => state.config.newsletterPopup);

    useEffect(() => {
        if (isMutationFulfilled(newsletterResult)) {
            dispatch(Actions.setNewsletterStatus(newsletterResult.data.isSuccess));
            dispatch(Actions.setNewsletterSubscriptionResultText(newsletterResult.data.result));
            AnalyticsManager.logSubscribeToNewsletter({
                personalId: form.personalId.val,
                firstName: form.firstName.val,
                lastName: form.lastName.val,
                cellphone: form.cellphone.val,
                email: form.email.val,
                source: AnalyticsParamValues.NEWS_LETTER_FORM,
                newsLetterResult: newsletterResult.data.code
            })

            onSubmit()

            const NUM_OF_SECONDS_TILL_POPUP_CLOSE = newsletterPopup?.minOfSecondsTillPopupClose || parameters.numOfSecondsTillNewsletterPopupClose

            setTimeout(() => {
                dispatch(Actions.removePopup());
            }, NUM_OF_SECONDS_TILL_POPUP_CLOSE * 1000)
        }
    }, [newsletterResult]);

    const [firstTry, setFirstTry] = useState(true);
    const [form, setForm] = useState({});

    const initializeForm = () => {
        if (!newsletterPopup?.formFields) return;
        
        const initialForm = {};
        newsletterPopup.formFields.forEach(field => {
            const rules = [];
            if (field.isRequired) {
                rules.push('not_empty');
            }
            
            if (field.isRequired && NewsletterFieldValidationRules[field.type]) {
                rules.push(NewsletterFieldValidationRules[field.type]);
            }
            
            initialForm[field.name] = {
                val: '',
                valid: false,
                rules: rules,
                errMsg: '',
                text: field.text,
                isRequired: field.isRequired,
                isHidden: field.isHidden
            };
        });
        
        setForm(initialForm);
    };

    useEffect(() => {
        initializeForm();
    }, [newsletterPopup]);

    const text = useSelector(state => {
        return state.config.Translations
    })
    const isSubscribe = useSelector(state => {
        return state.data.Newsletter_subscribe
    })
    const policy_page_url = useSelector(state => {
        return state.data.policy_page_id
    })
    const Newsletter_subscription_result_text = useSelector(state => {
        return state.data.Newsletter_subscription_result_text
    })

    const [condition, setCondition] = useState({
        checked: false,
        errMsg: text['newsletter_web_checkbox_error'],
    });

    useEffect(() => {
        adjustFormBasedOnUserData();
    }, [userData]);

    const adjustFormBasedOnUserData = () => {
        if (!newsletterPopup?.formFields) return;
        
        setForm(prevForm => {
            const updatedForm = { ...prevForm };
            
            newsletterPopup.formFields.forEach(field => {
                if (updatedForm[field.name]) {
                    const rules = [];
                    if (field.isRequired && !userData) {
                        rules.push('not_empty');
                        
                        if (NewsletterFieldValidationRules[field.type]) {
                            rules.push(NewsletterFieldValidationRules[field.type]);
                        }
                    }
                    
                    let userValue = '';
                    switch (field.name) {
                        case NewsletterFieldTypeLabels[NewsletterFieldTypes.PERSONAL_ID]:
                            userValue = userData?.user_id || '';
                            break;
                        case NewsletterFieldTypeLabels[NewsletterFieldTypes.FIRST_NAME]:
                            userValue = userData?.first_name || '';
                            break;
                        case NewsletterFieldTypeLabels[NewsletterFieldTypes.LAST_NAME]:
                            userValue = userData?.last_name || '';
                            break;
                        case NewsletterFieldTypeLabels[NewsletterFieldTypes.EMAIL]:
                            userValue = userData?.email || '';
                            break;
                        case NewsletterFieldTypeLabels[NewsletterFieldTypes.CELLPHONE]:
                            userValue = userData?.phone || '';
                            break;
                    }
                    
                    updatedForm[field.name] = {
                        ...updatedForm[field.name],
                        rules: rules,
                        val: userValue,
                    };
                }
            });
            
            return updatedForm;
        });
    };

    const handleSubmit = async (e) => {
        AnalyticsManager.logSubscribeToNewsletterPopupSubmitted()
        e.preventDefault();
        let formValid = true;
        let newForm = {...form};

        for (let field in form) {
            let validate = Validate(form[field].val, form[field].rules);
            let isValid = validate.valid;
            let msg = validate.msg;

            newForm[field].valid = isValid;
            newForm[field].errMsg = msg;

            if (isValid === false) {
                formValid = false;
            }
        }

        setForm(newForm);
        setFirstTry(false);

        if (formValid && condition.checked) {
            let payload = {};
            for (let key in form) {
                payload[key] = form[key].val;
            }
            signUpForNewsletter(payload)
            AnalyticsManager.logSubscribeToNewsletterPopupSuccess()
        } else {
            AnalyticsManager.logSubscribeToNewsletterPopupFailed()
        }
    };

    const handleInputChange = (e) => {
        const name = e.target.name;
        const val = e.target.value.trim();

        let validate = Validate(val, form[name].rules);
        let isValid = validate.valid;
        let msg = validate.msg;

        setForm(prevForm => ({
            ...prevForm,
            [name]: {...prevForm[name], val, valid: isValid, errMsg: msg}
        }));
    };

    const handleCheckboxOnClick = () => {
        setCondition(prevCondition => ({
            ...prevCondition,
            checked: !prevCondition.checked
        }));
    };

    const ishowErrorMsg = !firstTry && Object.values(form).some(field => !field.valid);
    const showErrorCB = !firstTry && !condition.checked;

    return (
        <form id="newsletter" className={'news-latter ' + className} onSubmit={handleSubmit}>
            {!isSubscribe && (
                <>
                    {isShowFormTitle && <span className='label'>{text['marketing_footer_title']}</span>}
                    <div className='mail-wrapper'>
                        {(() => {
                            if (!newsletterPopup?.formFields) return null;
                            
                            const visibleFields = newsletterPopup.formFields.filter(field => !field.isHidden);
                            const rows = [];
                            let currentRow = [];
                            
                            visibleFields.forEach((field, index) => {
                                const fieldData = form[field.name];
                                if (!fieldData) return;
                                
                                const getInputType = () => {
                                    return NewsletterFieldInputTypes[field.type] || 'text';
                                };
                                
                                const getUserDataValue = () => {
                                    switch (field.name) {
                                        case NewsletterFieldTypeLabels[NewsletterFieldTypes.PERSONAL_ID]: return userData?.user_id;
                                        case NewsletterFieldTypeLabels[NewsletterFieldTypes.FIRST_NAME]: return userData?.first_name;
                                        case NewsletterFieldTypeLabels[NewsletterFieldTypes.LAST_NAME]: return userData?.last_name;
                                        case NewsletterFieldTypeLabels[NewsletterFieldTypes.EMAIL]: return userData?.email;
                                        case NewsletterFieldTypeLabels[NewsletterFieldTypes.CELLPHONE]: return userData?.phone;
                                        default: return null;
                                    }
                                };
                                
                                const isInactive = !!getUserDataValue();
                                
                                const fieldElement = (
                                    <div key={field.name} className='input-wrapper-popup'>
                                        <input
                                            className={`input-element-popup ${isInactive ? 'inactive-element' : 'active-element'}`}
                                            type={getInputType()}
                                            name={field.name}
                                            placeholder={field.text}
                                            aria-label={field.text}
                                            value={fieldData.val}
                                            onChange={handleInputChange}
                                            dir="rtl"
                                        />
                                        {ishowErrorMsg && <div className='error-msg'>{fieldData.errMsg}</div>}
                                    </div>
                                );
                                
                                currentRow.push(fieldElement);
                                
                                // If this is a half-width field (widthSize: 0) and we have 2 fields in current row, or if it's full width, create a new row
                                if (field.widthSize === 0 && currentRow.length === 2) {
                                    rows.push(
                                        <div key={`row-${rows.length}`} className={isShow2Columns ? 'form-row' : ''} style={{justifyContent: 'space-between'}}>
                                            {currentRow}
                                        </div>
                                    );
                                    currentRow = [];
                                } else if (field.widthSize !== 0) {
                                    // Full width field - create row with single field
                                    rows.push(
                                        <div key={`row-${rows.length}`} className={isShow2Columns ? 'form-row' : ''} style={{justifyContent: 'space-between'}}>
                                            {currentRow}
                                        </div>
                                    );
                                    currentRow = [];
                                }
                            });
                            
                            // Add any remaining fields in currentRow
                            if (currentRow.length > 0) {
                                rows.push(
                                    <div key={`row-${rows.length}`} className={isShow2Columns ? 'form-row' : ''} style={{justifyContent: 'space-between'}}>
                                        {currentRow}
                                    </div>
                                );
                            }
                            
                            return rows;
                        })()}
                        <div className='cb-wrapper' onClick={handleCheckboxOnClick}>
                            <img
                                className='cb-img'
                                src={condition.checked ? getMediaPath(cb_checked) : getMediaPath(cb_empty)}
                                alt=''
                            />
                            <input
                                id={checkbox_id}
                                type='checkbox'
                                className='cb'
                                name='conditions'
                                disabled
                                aria-label="מסכים לתנאי השימוש"
                            />
                            <label htmlFor={checkbox_id}>
                                <span onClick={e => {
                                    if (e) {
                                        e.stopPropagation();
                                    }
                                }}>{ReactHtmlParser(newsletterPopup?.formCheckboxes?.[0]?.text || text['web_newsletter_agreemnet'], reactParserCommonOptions())}</span>
                                <NavLink to={"/" + policy_page_url} className="link" target="_blank"
                                         onClick={(e) => e.stopPropagation()}>
                                    {text.web_to_policy}
                                </NavLink>
                            </label>
                            {showErrorCB && <div className='error-msg'>{condition.errMsg}</div>}
                        </div>
                        <div className='submit-wrapper-popup'>
                            <button
                                className='submit-btn-popup'
                                type='submit'
                                name="submit"
                                value=''
                                aria-label="שלח"
                            ></button>
                            {show_img ? (
                                <img className='mail-img' src={getMediaPath(newsletterPopup?.submitFooterImage || submit_footer)} alt='/'/>
                            ) : (
                                <span className='submit-span'>{text['marketing_footer_submit_button']}</span>
                            )}
                        </div>
                    </div>
                </>
            )}
            {isSubscribe && (
                <div
                    className='success'>{Newsletter_subscription_result_text && ReactHtmlParser(Newsletter_subscription_result_text, reactParserCommonOptions())}</div>
            )}
        </form>
    );
};

export default PopupNewsletterForm;
